import { cx } from "@emotion/css";
import { identity } from "lodash/util";
import { useTranslation } from "react-i18next";
import { CircleChart } from "src/components/Statistics/CircleChart";
import { ExamSimpleStatistics } from "src/components/Statistics/exam/ExamSimpleStatistic";

interface CourseSectionStats {
	score: number;
	correctAnswersPercent: number;
	wrongAnswersPercent: number;
	cancelledQuestionsPercent: number;
	skippedQuestionsPercent: number;
	totalQuestions: number;
	correctAnswers: number;
	wrongAnswers: number;
	skippedQuestions: number;
	cancelledQuestions: number;
}

interface CourseSectionStatisticsProps {
	stats: CourseSectionStats;
}

export const CourseSectionStatistics = ({ stats }: CourseSectionStatisticsProps) => {
	const { t } = useTranslation();
	return (
		<div className="flex flex-col gap-12">
			<div className="flex items-center justify-between gap-20 flex-col">
				<div className="flex items-center gap-12 justify-between w-100">
					<span className="size-16-light text-center">
						{t("modals.statistics.currentScore")}
					</span>
					<span className={cx("size-20-light")}>{stats.score}%</span>
				</div>
				<div className="flex justify-between gap-24 w-100">
					<div>
						<CircleChart
							stats={stats}
							onClick={identity}
							title={t("modals.statistics.answers")}
						/>
					</div>
					<ExamSimpleStatistics stats={stats} className="flex-1" />
				</div>
			</div>
		</div>
	);
};
